import { useLanguage } from './language-context';
import { useTheme } from './theme-context';

// v3's header theme control: a sliding switch with a sun and moon, not a cycling
// icon button. It is a real switch — role and checked state are exposed, so a screen
// reader announces "on/off" rather than reading a decorative glyph.
//
// Clicking sets an explicit light/dark preference. "System" remains reachable, but is
// not a third click-through state here: v3's control is binary, and a user who wants
// to follow the OS again clears the preference from the footer.
// `size="sm"` is the mobile home bar's 56 x 30 variant (design DC:204).
export function ThemeSwitch({ size }: { size?: 'sm' } = {}) {
  const { t } = useLanguage();
  const { resolved, setPref } = useTheme();
  const isDark = resolved === 'dark';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={t(isDark ? 'theme.switch_to_light' : 'theme.switch_to_dark')}
      className={size === 'sm' ? 'themeswitch themeswitch--sm' : 'themeswitch'}
      onClick={() => setPref(isDark ? 'light' : 'dark')}
    >
      <span className="themeswitch__knob" aria-hidden="true" />
      <span className="themeswitch__ico themeswitch__ico--sun" aria-hidden="true">
        ☀
      </span>
      <span className="themeswitch__ico themeswitch__ico--moon" aria-hidden="true">
        ☾
      </span>
    </button>
  );
}
